import {
  GraphQLID,
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLString
} from 'graphql'
import { Context } from '../shared'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'

export interface PersistStigTemplateArgs {
  readonly input: {
    readonly organizationID: string
    readonly applicationID: string
    readonly name: string
    readonly fileType: string
    readonly content: string
  }
}

export const persistStigTemplateArgType = new GraphQLInputObjectType({
  name: 'PersistStigTemplateArgs',
  description:
    'Parameters to persist a STIG template for a specific application',
  fields: () => ({
    organizationID: {
      description: 'The ID of the organization',
      type: new GraphQLNonNull(GraphQLID)
    },
    applicationID: {
      description: 'The ID of the application',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'The name of the template',
      type: new GraphQLNonNull(GraphQLString)
    },
    fileType: {
      description: 'The file type of the template',
      type: new GraphQLNonNull(GraphQLString)
    },
    content: {
      description: 'The content of the template',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})

export const persistStigTemplateArgs = {
  input: {
    type: persistStigTemplateArgType
  }
}

export const persistStigTemplate: GraphQLFieldConfig<
  any,
  Context,
  PersistStigTemplateArgs
> = {
  description: 'Persists a STIG template',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: persistStigTemplateArgs,
  resolve: async (
    _source,
    args: PersistStigTemplateArgs,
    context: Context
  ): Promise<GenericMutationResponse> => {
    const {
      input: { organizationID, applicationID, name, fileType, content }
    } = args
    const { connector } = context
    await connector.post(
      `/${organizationID}/applications/${applicationID}/stig`,
      {
        name,
        file_type: fileType,
        content
      }
    )

    return { _placeholder: true }
  }
}
